import script from "./SoftwareKeyboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SoftwareKeyboard.vue?vue&type=script&lang=ts&setup=true"

import "./SoftwareKeyboard.vue?vue&type=style&index=0&id=8ebe3ffc&lang=scss"

const __exports__ = script;

export default __exports__